// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html{font-family:\"Amazon Ember\",\"Helvetica Neue\",Roboto,Arial,sans-serif}", ""]);
// Exports
module.exports = exports;
